// extracted by mini-css-extract-plugin
module.exports = {"arrowBtn":"qp_qq g2_g3","arrowBtnPrev":"qp_qr qp_qq g2_g3","arrowBtnNext":"qp_qs qp_qq g2_g3","arrowBtnDisabled":"qp_qt qp_qq g2_g3","arrow":"qp_qk","arrowSmall":"qp_qu"};